import styles from './Page.module.css';
import React, { useState, useEffect } from 'react';
import { format, addHours } from 'date-fns';


function RevImpPage() {
  // const [documents, setDocuments] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [documentsForBase, setDocumentsForBase] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [locationsList, setLocationsList] = useState([]);
  const [lastDocumentToBase, setLastDocumentToBase] = useState(0);

  useEffect(() => {
    async function getNewsList() {
      const response = await fetch('/api/reviews/forRevImpNewsList');
      const data = await response.json();
      // setNewsList(data);
      setDocumentsForBase(data.map((document) => ({ ...document, top: false, important: false, categories: document.categories || [] })));
    }
    getNewsList();
    async function getCategories() {
      // const dataForRequest = {
      //   // source: 'UP'
      // };
      const response = await fetch('/api/reviews/getcategoriesList', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        // body: JSON.stringify(dataForRequest)
      });
      let data = await response.json();
      // Функція порівняння для сортування за полем name
      function compareByName(a, b) {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      }

      // Сортування масиву за полем name
      data.sort(compareByName);
      setCategoriesList(data);
    }
    getCategories();
    async function getLocations() {
      // const dataForRequest = {
      //   source: 'UP'
      // };
      const response = await fetch('/api/reviews/getLocationsList', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        // body: JSON.stringify(dataForRequest)
      });
      let data = await response.json();
      // Функція порівняння для сортування за полем name
      function compareByName(a, b) {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      }

      // Сортування масиву за полем name
      data.sort(compareByName);
      setLocationsList(data);
    }
    getLocations();
  }, []);

  

  const handleToggleTop = (index) => {
    const newItems = [...documentsForBase];
    newItems[index].top = !newItems[index].top;
    if (newItems[index].top) {
      newItems[index].important = true;
      newItems[index].telegram = "must_publish";
    } else {
      newItems[index].important = false;
      newItems[index].telegram = "";

    }
    setDocumentsForBase(newItems);
    updateListToBase(index);
  };

  const handleToggleImportant = (index) => {
    const newItems = [...documentsForBase];
    newItems[index].important = !newItems[index].important;
    newItems[index].telegram = newItems[index].important ? "must_publish" : "";
    setDocumentsForBase(newItems);
    updateListToBase(index);
  };

  const handleToggleNoPublish = (index) => {
    const newItems = [...documentsForBase];
    newItems[index].nopublish = !newItems[index].nopublish;
    setDocumentsForBase(newItems);
    updateListToBase(index);
  };

  function handleCategoryClick(docIndex, currentCategory) {
    // create a copy of the clonedDocuments array
    const newClonedDocuments = [...documentsForBase];
    const categoryExists = newClonedDocuments[docIndex].categories.some(
      (category) => category === currentCategory.name
    );
    if (categoryExists) {
      // remove the similarity from the clonedDocuments array
      newClonedDocuments[docIndex].categories = newClonedDocuments[docIndex].categories.filter(
        (category) => category !== currentCategory.name
      );
    } else {
      // add the similarity to the clonedDocuments array
      newClonedDocuments[docIndex].categories.push(currentCategory.name);
    }
  
    console.log(newClonedDocuments[docIndex].categories);
  
    // update the state with the new clonedDocuments array
    setDocumentsForBase(newClonedDocuments);
    if (docIndex > lastDocumentToBase) {
      setLastDocumentToBase(docIndex);
    }
  }

  function handleLocationClick(docIndex, currentLocation) {
    // create a copy of the clonedDocuments array
    const newClonedDocuments = [...documentsForBase];
    const locationExists = newClonedDocuments[docIndex].location === currentLocation.name;
    if (locationExists) {
      // remove the similarity from the clonedDocuments array
      newClonedDocuments[docIndex].location = [];
    } else {
      // add the similarity to the clonedDocuments array
      newClonedDocuments[docIndex].location = currentLocation.name;
    }
  
    console.log(newClonedDocuments[docIndex].categories);
  
    // update the state with the new clonedDocuments array
    setDocumentsForBase(newClonedDocuments);
    if (docIndex > lastDocumentToBase) {
      setLastDocumentToBase(docIndex);
    }
  }

function updateListToBase(docIndex) {
  if (docIndex > lastDocumentToBase) {
    setLastDocumentToBase(docIndex);
  }
}

const handleSave = async () => {
  setIsSaving(true);
  const reviewedNews = documentsForBase.slice(0, lastDocumentToBase+1);
  reviewedNews.forEach(function(item) {
    if (item.nopublish) {
      item.stage = "no-publish";
    } else {
      item.stage = "for-publish";
    }
    const currentDate = new Date();
    const updatedDate = addHours(currentDate, 3);
    const updatedAt = format(updatedDate, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");

    item.updatedAt = updatedAt;
  });
  if (reviewedNews.length > 0) {
    try {
      await  fetch('/api/reviews/importancereviewednewstobase', {
        method: 'POST',
        body: JSON.stringify(reviewedNews),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        // Обробка відповіді сервера
      })
      .catch(error => {
        // Обробка помилки
      });
      setIsSaving(false);
      setLastDocumentToBase(0);
      const response = await fetch('/api/reviews/forRevImpNewsList');
      const data = await response.json();
      // setNewsList(data);
      setDocumentsForBase(data);

      // Прокрутка сторінки до початку
      window.scrollTo(0, 0);
    } catch (error) {
      console.error(error);
      setIsSaving(false);
    }

  }
  setIsSaving(false);
};

  return (
    <div className={styles.root}>
      <button onClick={handleSave} disabled={isSaving} style={{ position: "fixed", top: 0 }}>
        {isSaving ? "Saving..." : "Save Important News"}
      </button>      
      {documentsForBase.map((document, docIndex) => (
        <div key={document.id} className={styles.document}>
          <h2 className={styles.title}>{document.title} (<a href={document.url} target="_blank">відкрити</a>)</h2>
          <button 
            onClick={() => handleToggleTop(docIndex)}
            className={document.top ? styles.active : ""}
          >
            {document.top ? 'Unset Top' : 'Set Top'}
          </button>
          <button 
            onClick={() => handleToggleImportant(docIndex)}
            className={document.important ? styles.active : ""}
          >
            {document.important ? 'Unset Important' : 'Set Important'}
          </button>
          <button 
            onClick={() => handleToggleNoPublish(docIndex)}
            className={document.nopublish ? styles.active : ""}
          >
            {document.nopublish ? 'Set Publish' : 'Set Unpublish'}
          </button>
          <hr />
          {categoriesList.filter(category => category.source === document.source).map(category => (
                <button 
                  key={category._id}
                  // className={documentsForBase[docIndex].categories.some(
                  //   (categoryOriginal) => categoryOriginal._id === category._id) ? styles.active : ""}
                  className={documentsForBase[docIndex].categories.some(
                    (categoryOriginal) => categoryOriginal === category.name) ? styles.active : ""}

                  onClick={() => handleCategoryClick(docIndex, category)}
                >
                  {category.name}
                </button>
            ))}
          <hr />
          {locationsList.filter(location => location.source === document.source).map(location => (
                <button 
                  key={location._id}
                  // className={documentsForBase[docIndex].categories.some(
                  //   (categoryOriginal) => categoryOriginal._id === category._id) ? styles.active : ""}
                  className={documentsForBase[docIndex].location === location.name ? styles.active : ""}

                  onClick={() => handleLocationClick(docIndex, location)}
                >
                  {location.name}
                </button>
            ))}
        </div>
      ))}
    </div>
  );
}

export default RevImpPage;
